import { deleteDoc, doc, increment, updateDoc } from "firebase/firestore";
import { deleteObject, ref } from "firebase/storage";
import { db, storage } from "../../app/firebase";
import { toDateKey } from "./date";
import type { LogEvent } from "../types/domain";

export async function deleteLogEvent(babyId: string, item: LogEvent): Promise<void> {
  const dateKey = toDateKey(item.occurredAt);
  const healthConditionTypes = ["vomiting", "hiccup", "fever", "pain"];
  const isHealthCondition = healthConditionTypes.includes(item.type);
  const attachmentPaths: string[] = [];
  if (item.payload.imagePath) attachmentPaths.push(item.payload.imagePath);
  if (item.payload.filePath) attachmentPaths.push(item.payload.filePath);
  const legacyUrls = [
    item.payload.imagePath ? null : item.payload.imageUrl,
    item.payload.filePath ? null : item.payload.fileUrl,
  ].filter(Boolean) as string[];
  for (const url of legacyUrls) {
    try {
      const { pathname } = new URL(url);
      const match = pathname.match(/\/o\/(.+)/);
      if (match) attachmentPaths.push(decodeURIComponent(match[1]));
    } catch {
      // ignore malformed URL
    }
  }
  await Promise.all(attachmentPaths.map(async (path) => {
    try { await deleteObject(ref(storage, path)); } catch { /* file may already be absent */ }
  }));
  await deleteDoc(doc(db, "babies", babyId, "logEvents", item.id));
  const delta: Record<string, unknown> = {};
  if (item.type === "feed") {
    delta.feedCount = increment(-1);
    if (item.payload.feedMethod === "nursing") delta.nursingCount = increment(-1);
    else delta.feedTotalMl = increment(-(item.payload.amountMl ?? 0));
  } else if (item.type === "sleep") {
    delta.sleepCount = increment(-1);
  } else if (item.type === "diaper") {
    if (item.payload.diaperKind === "wet") delta.diaperCountWet = increment(-1);
    else delta.diaperCountSoiled = increment(-1);
  } else if (item.type === "marker" || isHealthCondition) {
    delta.alertsCount = increment(-1);
  }
  if (Object.keys(delta).length > 0) {
    try {
      await updateDoc(doc(db, "babies", babyId, "dailyStats", dateKey), delta);
    } catch {
      // stats doc may not exist for older entries
    }
  }
}
